import React from "react";
import CcBadge from "../display/CcBadge";

/**
 * MUI Chip alias with the same Carecentre status / KLOE rules as CcBadge.
 */
const CcChip = ({
  tone = "active",
  label,
  pill = false,
  shape,
  uppercase,
  className,
  style,
  ...props
}) => (
  <CcBadge
    className={className}
    label={label}
    pill={pill}
    shape={shape}
    style={style}
    tone={tone}
    uppercase={uppercase}
    {...props}
  />
);

export default CcChip;
